import React, { useEffect, useState, useContext } from 'react';
import {
  Form, Container, Row,
} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination'; 
import { Button, ButtonGroup } from '@/shared/components/Button';
import { ShimmerSimpleGallery } from 'react-shimmer-effects';
import { FaExclamationCircle } from 'react-icons/fa'; // Optional icon for no data
import toast from 'react-hot-toast';
import { AgentContext } from '../../context/AgentContext';
import { AuthContext } from '../../context/AuthContext';
import RequestShort from './RequestShort';
import { SideBarRefreshContext } from '../../context/SideBarRefreshContext';

const RequestList = () => {
  const [request, setRequest] = useState([]);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [isLoading, setIsLoading] = useState(true); 
  const [errors, setError] = useState(null); 
  const [filterRequest, setFilterRequest] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { refresh, statusChanged, setRefresh } = useContext(AgentContext);
  const { apiGlobal } = useContext(AuthContext);
   // Pagination state
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 10;
 

  const fetchData = async () => {
    try {
      const response = await fetch(`${apiGlobal}agent_notappro_list.php`);
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        setRequest(data.data);
        setFilterRequest(data.data);
      } else {
        setRequest([]);
        setFilterRequest([]);
      }
    } catch (error) {
      setError('Failed to load data. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = request.filter(requestdata => requestdata.name.toLowerCase().includes(query.toLowerCase()));
      console.log(filteredData);
      setFilterRequest(filteredData);
    } else {
      setFilterRequest(request);
    }
  };

  useEffect(() => {
    fetchData();
  }, [statusChanged, refresh, sideBarRefresh?.adminAgentRequestRefresh]);

  const refreshHandler = () => {
    setRefresh(prev => !prev);
    toast.success('refresh');
    setSearchQuery('');
  };

  // use Effect to add keyframes for the pulse animation
  useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  if (isLoading) {
    return (
      <div>
        {/* Map over an array of 5 items to display 5 shimmer content blocks */}
        {Array.from({ length: 3 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <ShimmerSimpleGallery key={index} card imageHeight={300} caption />
        ))}
      </div>
    );
  }

  

  if (errors) {
    return <div>{errors}</div>;
  }

   
    // Handle page change
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
  
    // Pagination Logic - Slice data for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  
    // Use filteragent for pagination, not agent
    const currentItems = filterRequest.slice(indexOfFirstItem, indexOfLastItem);
  
    // Total pages should be based on filteragent length, not agent
    const totalPages = Math.ceil(filterRequest.length / itemsPerPage);
  
   // Generate a range of pagination items, including "..."
  const pageNumbers = [];
  const maxVisiblePages = 3; // This will display only 3 page numbers (e.g., 1, 2, 3 or 2, 3, 4)
  const startPage = Math.max(1, currentPage - 1); // Allow for 1 page before
  const endPage = Math.min(totalPages, currentPage + 1); // Allow for 1 page after
  
  // Add the page numbers in the range of startPage to endPage
  for (let i = startPage; i <= endPage; i += 1) {
    pageNumbers.push(i);
  }
  
  // If the first page is greater than 1, add '...'
  if (startPage > 1) {
    pageNumbers.unshift('...');
  }
  
  // If the last page is less than the total pages, add '...'
  if (endPage < totalPages) {
    pageNumbers.push('...');
  }
  
  // Add the last page number if it's not already in the array
  if (pageNumbers[pageNumbers.length - 1] !== totalPages) {
    pageNumbers.push(totalPages);
  }
  

  
  


  return (
    <Container>
      <Row>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{
            display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
          }}
          >
            <Form.Control
              type="text"
              placeholder="Search by Name......"
              value={searchQuery}
              onChange={handleSearch}
              style={{
                height: '30px',
                marginTop: '5px',
                borderColor: 'green',
                flexGrow: 1,
              }}
            />

            <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
              <Button
                variant="outline-secondary"
                title="Refresh"
                size="sm"
                style={{ marginLeft: '10px' }}
                onClick={refreshHandler}
              >
                <span className="lnr lnr-sync" />
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </Row>

      <Row>
        {filterRequest.length > 0 ? (
          filterRequest.map((req, index) => (
            <RequestShort
              key={req.id}
              index={index}
              date={req.date}
              name={req.name}
              id={req.id}
              logo={req.logo}
            />
          ))
        ) : (
          // If search results are empty
          <div style={{
            textAlign: 'center',
padding: '50px',
backgroundColor: '#f8d7da',
borderRadius: '8px',
marginTop: '20px',
            color: '#721c24',
fontSize: '16px',
          }}
          >
            <div
              style={{
fontSize: '48px',
marginBottom: '20px',
color: '#e63946',
animation: 'pulse 1.5s infinite ease-in-out',
display: 'inline-block',
}}
            >
              <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
            </div>
            <p>{searchQuery ? 'No results found for your search' : 'No Agent requests available'}</p>
          </div>
        )}
      </Row>
      {/* Pagination Controls */}
      <div
        className=""
        style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
    zIndex: 999, 
    display: 'flex', 
    justifyContent: 'flex-end', 
    alignItems: 'center',

  }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
    ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </Container>
  );
};

export default React.memo(RequestList);
